// extracted by mini-css-extract-plugin
export default {"RegItemBadges":"RegItemBadges-styles__RegItemBadges__HquBw"};